import { render } from "./Documentation.vue?vue&type=template&id=2577497f&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"

import "./Documentation.vue?vue&type=style&index=0&id=2577497f&scoped=true&lang=css"

import exportComponent from "D:\\project\\clipshare\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2577497f"]])

export default __exports__